import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-core";

export const MORE_PAYMENTS_TEXTS = {
    SELECT_METHOD: "Select a method",
    MORE_PAYMENT_OPTIONS: "More Payment Options",
    MORE_OPTIONS: "More options",
};

export const MORE_METHODS_PAGE_TITLES = {
    [VALID_PAYMENT_GROUP_TYPES.CARD]: "Select a card",
    [VALID_PAYMENT_GROUP_TYPES.COD]: "Pay on delivery",
    [VALID_PAYMENT_GROUP_TYPES.FOOD_CARD]: "Select a card",
    [VALID_PAYMENT_GROUP_TYPES.NETBANKING]: "Select a bank",
    [VALID_PAYMENT_GROUP_TYPES.PAY_LATER]: "Pay Later",
    [VALID_PAYMENT_GROUP_TYPES.UPI]: "Select a bank",
    [VALID_PAYMENT_GROUP_TYPES.WALLET]: "Select a wallet",
    [VALID_PAYMENT_GROUP_TYPES.WALLET_WEB]: "Select a wallet",
    [VALID_PAYMENT_GROUP_TYPES.PREFERRED]: "Select preferred method",
    [VALID_PAYMENT_GROUP_TYPES.SWIGGY_INSTRUMENTS]: "Swiggy money",
};
